const Layout1Settings = {
  leftSidebar: {
    show: true,
    mode: 'full', // full, close, compact, mobile,
    theme: 'whiteBlue', // View all valid theme colors inside MatxTheme/themeColors.js
    bgImgURL: '/assets/images/sidebar/sidebar-bg-dark.jpg',
    bgOpacity: 0.92,
  },

  topbar: {
    show: true,
    fixed: true,
    theme: 'AceDark1', // View all valid theme colors inside MatxTheme/themeColors.js
  },
};

export default Layout1Settings;
